import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FieldsetComponent, SelectionTileComponent } from '@woolworthsnz/form';
import { SustainableBadgeComponent } from '@woolworthsnz/styleguide';
import { NgIf } from '@angular/common';

@Component({
	selector: 'account-packing-slip-preference',
	templateUrl: './packing-slip-preference.component.html',
	styleUrls: ['./packing-slip-preference.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [FieldsetComponent, FormsModule, ReactiveFormsModule, NgIf, SelectionTileComponent, SustainableBadgeComponent]
})
export class PackingSlipPreferenceComponent {
	@Input() formGroup: FormGroup;
	@Input() controlName: string;
	@Input() title: string;
	@Input() description: string;
}
